import { useMemo, useState, useEffect } from "react";

const useMapDimensions = (id: string) => {
  // Store the dimensions
  const [dimensions, setDimensions] = useState(() => {
    // Query for any we have now
    const element = document.getElementById(id);
    if (element) {
      return {
        width: element.clientWidth,
        height: element.clientHeight,
      };
    }
    return {
      width: 0,
      height: 0,
    };
  });

  // Observe the div id for changes
  const resizeObserver = useMemo(() => {
    // If window supports..
    if (typeof ResizeObserver === "function") {
      return new ResizeObserver((entries) => {
        for (const entry of entries) {
          setDimensions({
            width: entry.contentRect.width,
            height: entry.contentRect.height,
          });
        }
      });
    }
  }, [setDimensions]);

  useEffect(() => {
    // If we have a valid observer
    if (resizeObserver) {
      const element = document.getElementById(id);
      if (element) {
        resizeObserver.observe(element);
      }
    }
    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [id, resizeObserver]);

  return { dimensions };
};

export default useMapDimensions;
